// extracted by mini-css-extract-plugin
module.exports = {"root":"SaucerImage_root__sC2NU"};